module.exports = __webpack_public_path__ + "static/media/checked-icon.a1deacff.svg";